import _slicedToArray from "/codebuild/output/src3607656390/src/mdigital-online-morrisons.com-storefinder-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import ReactExports, { createContext, useContext, useRef, createElement, useReducer, useEffect, useDebugValue, useCallback } from 'react';
import { getDefaultStore, createStore } from 'jotai/vanilla';
var StoreContext = createContext(void 0);
var useStore = function useStore(options) {
  var store = useContext(StoreContext);
  return (options == null ? void 0 : options.store) || store || getDefaultStore();
};
var Provider = function Provider(_ref) {
  var children = _ref.children,
    store = _ref.store;
  var storeRef = useRef();
  if (!store && !storeRef.current) {
    storeRef.current = createStore();
  }
  return createElement(StoreContext.Provider, {
    value: store || storeRef.current
  }, children);
};
var isPromiseLike = function isPromiseLike(x) {
  return typeof (x == null ? void 0 : x.then) === "function";
};
var use = ReactExports.use || function (promise) {
  if (promise.status === "pending") {
    throw promise;
  } else if (promise.status === "fulfilled") {
    return promise.value;
  } else if (promise.status === "rejected") {
    throw promise.reason;
  } else {
    promise.status = "pending";
    promise.then(function (v) {
      promise.status = "fulfilled";
      promise.value = v;
    }, function (e) {
      promise.status = "rejected";
      promise.reason = e;
    });
    throw promise;
  }
};
function useAtomValue(atom, options) {
  var store = useStore(options);
  var _useReducer = useReducer(function (prev) {
      var nextValue = store.get(atom);
      if (Object.is(prev[0], nextValue) && prev[1] === store && prev[2] === atom) {
        return prev;
      }
      return [nextValue, store, atom];
    }, void 0, function () {
      return [store.get(atom), store, atom];
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    _useReducer2$ = _slicedToArray(_useReducer2[0], 3),
    valueFromReducer = _useReducer2$[0],
    storeFromReducer = _useReducer2$[1],
    atomFromReducer = _useReducer2$[2],
    rerender = _useReducer2[1];
  var value = valueFromReducer;
  if (storeFromReducer !== store || atomFromReducer !== atom) {
    rerender();
    value = store.get(atom);
  }
  var delay = options == null ? void 0 : options.delay;
  useEffect(function () {
    var unsub = store.sub(atom, function () {
      if (typeof delay === "number") {
        setTimeout(rerender, delay);
        return;
      }
      rerender();
    });
    rerender();
    return unsub;
  }, [store, atom, delay]);
  useDebugValue(value);
  return isPromiseLike(value) ? use(value) : value;
}
function useSetAtom(atom, options) {
  var store = useStore(options);
  var setAtom = useCallback(function () {
    if ((import.meta.env ? import.meta.env.MODE : void 0) !== "production" && !("write" in atom)) {
      throw new Error("not writable atom");
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return store.set.apply(store, [atom].concat(args));
  }, [store, atom]);
  return setAtom;
}
function useAtom(atom, options) {
  return [useAtomValue(atom, options),
  // We do wrong type assertion here, which results in throwing an error.
  useSetAtom(atom, options)];
}
export { Provider, useAtom, useAtomValue, useSetAtom, useStore };